import { render, staticRenderFns } from "./LedgerDetail.vue?vue&type=template&id=7028aa9e"
import script from "./LedgerDetail.vue?vue&type=script&lang=js"
export * from "./LedgerDetail.vue?vue&type=script&lang=js"
import style0 from "./LedgerDetail.vue?vue&type=style&index=0&id=7028aa9e&prod&media=screen&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports